<div *ngIf="employers.length > 0" class="overflow-x-auto">
  <table class="min-w-full text-left">
    <thead>
      <tr class="border-b border-gray-200">
        <th scope="col" class="py-3 pr-6 text-xs font-semibold tracking-wider uppercase text-chathams-blue">
          Colaborador
        </th>
        <th scope="col" class="px-6 py-3 text-xs font-semibold tracking-wider uppercase text-chathams-blue">
          Empresa / Filial
        </th>
        <th scope="col" class="px-6 py-3 text-xs font-semibold tracking-wider uppercase text-chathams-blue">
          Situação
        </th>
        <th scope="col" class="py-3 pl-6 text-xs font-semibold tracking-wider text-right uppercase text-chathams-blue">
          Ações
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let employee of employers" class="border-b border-gray-100 hover:bg-iceberg">
        <td class="py-3 pr-6">
          <div class="font-semibold text-chathams-blue">{{ employee.name }}</div>
          <div class="text-sm text-gray-500">
            {{ employee.role }}
          </div>
        </td>
        <td class="px-6 py-3">
          <div class="text-chathams-blue">{{ employee.subsidiary?.company?.name }}</div>
          <div class="text-sm text-gray-500">{{ employee.subsidiary?.name }}</div>
        </td>
        <td class="px-6 py-3 whitespace-nowrap">
          <ng-container *ngIf="statusInfo(employee.status) as info; else semSituacao">
            <span
              class="inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-semibold cursor-help"
              [ngClass]="info.badgeClass"
              [title]="info.hint"
              [attr.aria-label]="info.label + '. ' + info.hint"
            >
              <span class="w-1.5 h-1.5 rounded-full bg-current" aria-hidden="true"></span>
              {{ info.label }}
            </span>
          </ng-container>
          <ng-template #semSituacao>
            <span class="rounded-full px-3 py-1 text-xs font-semibold bg-gray-100 text-gray-700">Não informada</span>
          </ng-template>
        </td>
        <td class="py-3 pl-6">
          <div class="flex justify-end gap-2">
            <button
              type="button"
              class="flex items-center justify-center w-8 h-8 rounded-full bg-iceberg text-chathams-blue"
              [attr.aria-label]="'Visualizar colaborador ' + employee.name"
              [title]="'Visualizar'"
              (click)="abrirDetalhes(employee.id!)"
            >
              <lucide-icon name="eye" [size]="18"></lucide-icon>
            </button>

            <a
              *isAllowed="[ERoleAdminString.Admin, 'employee.update', 'employee.edit']"
              class="flex items-center justify-center w-8 h-8 rounded-full bg-iceberg text-chathams-blue"
              [routerLink]="'editar/' + employee.id"
              [attr.aria-label]="'Editar colaborador ' + employee.name"
              [title]="'Editar'"
            >
              <lucide-icon name="pencil" [size]="18"></lucide-icon>
            </a>

            <button
              *isAllowed="deletePermissions"
              type="button"
              class="flex items-center justify-center w-8 h-8 rounded-full bg-iceberg text-chathams-blue"
              [attr.aria-label]="'Excluir colaborador ' + employee.name"
              [title]="'Excluir'"
              [disabled]="excluindo"
              (click)="excluir(employee)"
            >
              <lucide-icon name="trash-2" [size]="18"></lucide-icon>
            </button>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
<app-no-results-found [condition]="employers.length === 0"></app-no-results-found>
<div class="flex justify-end mb-5">
  <app-paginacao
    [numeroDeItens]="dadosPaginacao.itensTotal"
    [tamanhoDaPagina]="dadosPaginacao.tamanhoPagina"
    [paginaSelecionada]="dadosPaginacao.paginaSelecionada"
    [totalPage]="dadosPaginacao.totalPaginas"
    (mudouPagina)="mudouPagina.emit($event)"
    (mudouTamanhoPagina)="mudouTamanhoPagina.emit($event)"
  ></app-paginacao>
</div>

<app-employee-details-modal
  *ngIf="modalDetalhesAberto"
  [employeeId]="detalhesColaboradorId"
  (fechar)="fecharDetalhes()"
></app-employee-details-modal>
